export default {
  handleDocumentContainer: {
    title: 'Allega un preventivo',
    text: 'Presentaci un preventivo di un artigiano di tua scelta. Questo sarà esaminato dal nostro team tecnico che lo convaliderà o ti contatterà se necessario.',
    billmaSolution: {
      title: 'Danni immobiliari',
      solution: 'Soluzione: Scegliere il mio artigiano',
      text1: 'Allega ora il preventivo del tuo artigiano per l’analisi.',
      text2: 'Inviando i tuoi documenti, accetti che vengano analizzati manualmente o da un algoritmo.',
      text3: 'Preventivo:',
      uploadBtn: 'Aggiungi un documento'
    },
    actions: {
      primary: 'Continua'
    },
    documentUploadStep: {
      actions: {
        primary: 'Allega un documento'
      }
    },
    icrModal: {
      title: 'Caricamento dei file',
      text1: 'I file sono attualmente in fase di elaborazione. Si prega di continuare ad aspettare.',
      text2: 'Il processo può richiedere alcuni minuti.',
      text3: 'Stiamo elaborando i suoi documenti. In pochi minuti convalideremo il suo compenso.'
    }
  }
}
